import React, { useState, useEffect } from "react";
import "../custom_scss/custom.scss";

const testimonials = [
  {
    quote:
      "John has been amazing to work with… once we saw the final product, the team was through the roof with excitement.",
    client: "Bedro Whitening",
  },
  {
    quote: "Wonderful professionalism! I’d work with John again.",
    client: "Josephine Alexander",
  },
  {
    quote:
      "John did a great job completing our project… I will definitely work with him again.",
    client: "SPAC Research",
  },
];

const TestimonialCarousel = () => {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const fadeOutTimer = setTimeout(() => setFade(false), 4500); // fade out after 5s
    const nextTimer = setTimeout(() => {
      setIndex((prev) => (prev + 1) % testimonials.length);
      setFade(true);
    }, 5500); // new testimonial after 6s

    return () => {
      clearTimeout(fadeOutTimer);
      clearTimeout(nextTimer);
    };
  }, [index]);

  return (
    <div
      className={`flex-col testimonial-section testimonial-carousel ${
        fade ? "fade-in" : "fade-out"
      }`}
    >
      <h4 className="testimonial-h4">
        <span style={{ color: "var(--primary-color)" }}>“</span>
        {testimonials[index].quote}
        <span style={{ color: "var(--primary-color)" }}>”</span>
      </h4>
      <p className="testimonial-client">
        <span style={{ color: "var(--primary-color)" }}>—</span>{" "}
        {testimonials[index].client}
      </p>
    </div>
  );
};

export default TestimonialCarousel;
